import './App.css';
import Hero from './components/sections/hero/index.jsx';
import About from './components/sections/about/index.jsx';
import Skills from './components/sections/skills/index.jsx';
import Projects from './components/sections/projects/index.jsx';
import Contact from './components/sections/contact/index.jsx';
import BackToTopButton from './components/BackToTop.jsx';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-black">
      {/* Background glassmorphism */}
      <div className="fixed inset-0 bg-gradient-to-r from-emerald-500/10 to-green-400/10 blur-3xl"></div>
      <div className="fixed top-1/4 left-1/4 w-96 h-96 bg-emerald-400/20 rounded-full blur-3xl"></div>
      <div className="fixed bottom-1/4 right-1/4 w-96 h-96 bg-green-500/15 rounded-full blur-3xl"></div>
      <div className="fixed top-3/4 left-1/2 w-64 h-64 bg-lime-400/10 rounded-full blur-2xl"></div>
      
      <div className="relative z-10">
        <BackToTopButton />
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </div>
    </div>
  );
}

export default App;